/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { map } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { CalculatedParams } from '@linc-technologies/linced-common/enums/group-auto-groups';
import { tracked } from '@glimmer/tracking';
import { filterBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class GroupsList extends Component {
  @service
  features;

  @service
  roles;

  @service
  router;

  groupType = 'my';

  groupImageClasses = Object.freeze([
    'group-profile-image',
    'layout-row',
    'layout-wrap',
    'layout-align-end-start',
  ]);

  @tracked
  group = null;

  @tracked
  navCardOpen = false;

  @action
  setNavCardOpen(value) {
    this.navCardOpen = value;
  }

  onCardClose() {}

  @map('groups', function (group) {
    let numLearners = filterBy(group.learners, 'status', 1).length;
    if (group.membershipHidden) {
      // Sort groups with hidden membership at the extreme low end.
      numLearners = -1;
    }
    return {
      group,
      numLearners,
      teachers: mapBy(group.get('currentStaff'), 'fullName').join(', '),
    };
  })
  rows;

  @action
  goToRoute(route, group) {
    // Close the group selector.
    this.onCardClose(true);

    // Then transition to the requested route.
    let options = {
      queryParams: null,
    };
    if (
      group.get('type') === GroupType.AUTO &&
      group.get('params.type') === CalculatedParams.RECENT_LEAVERS
    ) {
      options.queryParams = { includeFormers: true };
    }
    this.router.transitionTo(route, group.id, options);
  }

  @action
  openCard(group) {
    this.group = group;
    this.navCardOpen = true;
  }
}
